/**
 * SimilarBooksRail — "You might like", the recursive discovery-loop entry
 * point: every card links to that book's own Book Details page (its own
 * SimilarBooksRail populates again from there). Uses the same BookCard
 * primitive as Home's dashboard rails, so it looks like the rest of the app.
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { SectionHeader, BookCard } from '@/components/site/primitives';
import { bookHref } from '@/lib/bookModel';
import { useSimilarBooks } from './hooks/useSimilarBooks';

export default function SimilarBooksRail({ book }) {
  const { books, reasonFor } = useSimilarBooks(book);
  if (!books.length) return null;

  return (
    <section className="u-container mt-14 md:mt-20" data-testid="book-details-similar">
      <SectionHeader eyebrow="Discover more" title="You might like" />
      <div className="mt-6 flex gap-5 overflow-x-auto pb-2 scrollbar-none sm:grid sm:grid-cols-3 sm:overflow-visible lg:grid-cols-4">
        {books.map((candidate) => (
          <Link key={candidate.id} to={bookHref(candidate)} state={{ hint: candidate }} className="w-36 shrink-0 sm:w-auto">
            <BookCard
              title={candidate.title}
              author={candidate.authors?.[0] ?? candidate.author}
              rating={candidate.rating}
              tone={candidate.tone}
            />
            <p className="mt-1.5 text-[11px] italic text-subtle">{reasonFor(candidate)}</p>
          </Link>
        ))}
      </div>
    </section>
  );
}
